.basic-info-wrapper {
  display: block;
}

.page-container {
  position: relative;
  display: block;
  width: 100%;
  background-size: cover;
  border-radius: 3px;
  height: 100%;
  outline: none;
  appearance: none;
  border: none;

  &:focus-visible:not(.active &) {
    box-shadow: 0 0 0 2px #4c9ffe;
  }
}

.shot-container {
  position: relative;
  transition: 0.3s all ease;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  background: var(--card-bg-color);
  border-radius: var(--card-border-radius);
  border: var(--storyboard-border-color);
  user-select: none;
  height: 100%;
}

.insert-tile {
  border-radius: 0.8rem;
  font-size: 1.6rem;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  color: transparent;
  cursor: pointer;
  user-select: none;
}

.insert-overlay {
  display: none;
  position: absolute;
  right: -1.6rem;
  top: 50%;
  width: 1.6rem;
  transition: all 0.1s ease-in-out;
  height: 80%;
  transform: translateY(-50%);
  justify-content: center;
  align-items: center;
  color: transparent;
  cursor: default;

  &:hover {
    width: 30%;
    right: -10%;

    & > .insert-tile {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      width: 40%;
      border: dashed 2px white;
      color: white;
    }

    & + div {
      transform: scale(0.8) translateX(-5%) !important;
    }
  }

  @media screen and (min-width: 768px) {
    display: flex;
  }

  &[data-expand='true'] {
    width: 30%;
    right: -10%;

    & > .insert-tile {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      width: 40%;
      border: dashed 2px white;
      color: white;
    }

    & + div {
      transform: scale(0.8) translateX(-5%) !important;
    }
    & > * {
      pointer-events: none;
    }
  }
}

.subtitle-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.6rem;
}

.subtitle {
  z-index: 10;
  padding: 0.8rem;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 1.6rem;
  text-align: center;
  line-height: 2rem;
}

.cover {
  position: relative;

  &:hover + #action,
  &:hover > #action,
  &:hover #action {
    visibility: initial;
  }
}

.footer {
  position: relative;
  // padding: 1.2rem;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.order-indicator {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 8px;
  left: 8px;
  height: 2.4rem;
  width: 2.4rem;
  border-radius: 50%;
  background-color: var(--white-default);
  color: #111414;
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  z-index: 500;
  cursor: grab;
}

.block {
  display: flex;
  flex-direction: column;
}

.wrapper {
  height: 100%;
  position: relative;
  list-style: none;
  width: 100%;
  min-width: 100%;
  opacity: 1;

  &[data-active='true'] {
    opacity: 0.25;
  }
  transition: transform 200ms ease 0s;
  scroll-snap-align: center;

  &:hover {
    cursor: grab;
  }

  @media screen and (max-width: 640px) {
    &:nth-child(2n) {
      .insert-tile {
        opacity: 0;
      }
    }
  }

  @media screen and (min-width: 641px) and (max-width: 1240px) {
    &:nth-child(3n) {
      .insert-tile {
        opacity: 0;
      }
    }

    @media screen and (min-width: 1241px) {
      &:nth-child(4n) {
        .insert-tile {
          opacity: 0;
        }
      }
    }
  }

  &[data-zoom='1'],
  &[data-zoom='2'] {
    .footer,
    .basic-info-wrapper,
    .block {
      display: none;
    }

    .shot-container {
      height: unset;
    }
  }

  &[data-zoom='3'],
  &[data-zoom='4'] {
    .footer {
      display: flex;
    }

    .basic-info-wrapper {
      display: block;
    }

    .block {
      display: none;
    }
  }

  &[data-zoom='5'],
  &[data-zoom='6'] {
    .basic-info-wrapper {
      display: block;
    }

    .footer,
    .block {
      display: flex;
    }
  }
}
